// src/theme.js
import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// Create a custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#556cd6', // Example primary color
    },
    secondary: {
      main: '#19857b', // Example secondary color
    },
    error: {
      main: red.A400, // Default MUI error color
    },
  },
  typography: {
    // You can customize typography here, e.g., font family, font sizes
    // fontFamily: [
    //   'Roboto',
    //   '"Helvetica Neue"',
    //   'Arial',
    //   'sans-serif',
    // ].join(','),
  },
  spacing: 8, // Define a base spacing unit (default is 8px)
  components: {
    // Customize specific component styles here
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Example: make buttons not all caps
        },
      },
    },
    // ... add more component overrides as needed
  },
});

export default theme;